import {
  MemberListFilterBy,
  MemberListFilterByOperator,
  Role,
} from '@tribeplatform/gql-client/types'

export const sanitizeMemberFilters = (
  filters: MemberListFilterBy[],
  roles: Role[],
) => {
  return filters
    .map(filter => {
      if (filter.key === 'flagged') {
        return {
          ...filter,
          value: JSON.stringify(true),
        }
      }
      if (filter.key === 'role.name') {
        try {
          const roleName = JSON.parse(filter.value)
          const role = roles.find(role => role.name === roleName)
          if (role?.id) {
            return {
              key: 'roleId',
              operator: MemberListFilterByOperator.equals,
              value: JSON.stringify(role?.id),
            }
          }
        } catch (err) {
          logger.error('Could not parse role of the member filter')
        }
        return null
      }
      return filter
    })
    .filter(Boolean)
}
